import React, { useState, useEffect } from 'react';
import KitchenHeader from '../components/KitchenHeader';
import KitchenList from '../components/KitchenList';
import Loading from '../components/Loading';
import Error from '../components/Error';
import Footer from '../components/Footer';
import { fetchKitchenItems } from '../services/kitchenApi';
import { useKitchenCart } from '../context/KitchenCartContext';

const KitchenPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { cartItems } = useKitchenCart();
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    const getItems = async () => {
      try {
        setLoading(true);
        const data = await fetchKitchenItems();
        if (data && data.success && data.data && data.data.items) {
          setItems(data.data.items);
        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch kitchen items');
      } finally {
        setLoading(false);
      }
    };

    getItems();
  }, []);

  return (
    <>
      <KitchenHeader 
        searchQuery={searchQuery} 
        setSearchQuery={setSearchQuery} 
        cartCount={totalItems}
      />
      
      <main className="main-content">
        {loading ? (
          <Loading />
        ) : error ? (
          <Error message={error} />
        ) : (
          <KitchenList items={items} searchQuery={searchQuery} />
        )}
      </main>
      
      <Footer />
    </>
  );
};

export default KitchenPage;
